import {isNil, isNotNil} from 'ramda';

import {useGetBranchQuery} from '@dms/api/core';
import {useGetCurrentUserInfoQuery} from '@dms/api/customer';
import {useChangeBranchBusinessCaseMutation, useGetBusinessCaseQuery} from '@dms/api/sales';

import {TestIdProps} from 'shared/web';

import {handleApiError} from '../../../utils/handleApiError';
import {BranchChanger} from './BranchChanger';

export interface BusinessCaseBranchProps extends TestIdProps {
  recordId: string;
}

export function BusinessCaseBranch(props: BusinessCaseBranchProps) {
  const {data: businessCase} = useGetBusinessCaseQuery({
    businessCaseId: props.recordId,
  });
  const {data: currentUserInfo} = useGetCurrentUserInfoQuery();

  const [changeBranchBusinessCase] = useChangeBranchBusinessCaseMutation();

  const userAccessibleBranch = currentUserInfo?.branches?.find(
    (branch) => branch.id === businessCase?.branchId
  );

  const {data: branchById} = useGetBranchQuery(
    {branchId: businessCase?.branchId ?? ''},
    {skip: isNil(businessCase?.branchId) || isNotNil(userAccessibleBranch)}
  );

  const activeBranch = userAccessibleBranch ?? branchById;

  const handleUpdateBusinessCaseBranch = (branchId: string) =>
    changeBranchBusinessCase({
      businessCaseId: props.recordId,
      changeBranchBusinessCaseRequestBody: {
        branchId,
      },
    })
      .unwrap()
      .catch(handleApiError);

  return (
    <BranchChanger
      recordId={props.recordId}
      activeBranch={activeBranch}
      onChange={handleUpdateBusinessCaseBranch}
      data-testid={props['data-testid']}
    />
  );
}
